import React from "react"
export function IconStock() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.658 3.405L12.876 0.831C12.698 0.574831 12.4608 0.365481 12.1845 0.220788C11.9081 0.0760947 11.6009 0.000347282 11.289 0L3.711 0C3.39908 0.000347282 3.09187 0.0760947 2.81554 0.220788C2.53922 0.365481 2.30196 0.574831 2.124 0.831L0.342 3.405C0.119767 3.72696 0.000508337 4.10879 0 4.5L0 13.068C0 13.5804 0.203549 14.0718 0.56587 14.4341C0.92819 14.7965 1.4196 15 1.932 15H13.068C13.5804 15 14.0718 14.7965 14.4341 14.4341C14.7965 14.0718 15 13.5804 15 13.068V4.5C14.9995 4.10879 14.8802 3.72696 14.658 3.405ZM11.289 1.5C11.3587 1.49993 11.4273 1.51682 11.489 1.54923C11.5507 1.58164 11.6035 1.62858 11.643 1.686L12.759 3.3H8.259V1.5H11.289ZM3.357 1.686C3.39647 1.62858 3.44932 1.58164 3.511 1.54923C3.57268 1.51682 3.64133 1.49993 3.711 1.5H6.75V3.3H2.25L3.357 1.686ZM13.5 13.068C13.5004 13.1248 13.4895 13.1812 13.4679 13.2338C13.4464 13.2864 13.4146 13.3342 13.3744 13.3744C13.3342 13.4146 13.2864 13.4464 13.2338 13.4679C13.1812 13.4895 13.1248 13.5004 13.068 13.5H1.932C1.87516 13.5004 1.8188 13.4895 1.76621 13.4679C1.71362 13.4464 1.66584 13.4146 1.62564 13.3744C1.58545 13.3342 1.55364 13.2864 1.53207 13.2338C1.5105 13.1812 1.4996 13.1248 1.5 13.068V5.175C1.5 5.07554 1.53951 4.98016 1.60984 4.90983C1.68016 4.83951 1.77554 4.8 1.875 4.8H13.125C13.2245 4.8 13.3198 4.83951 13.3902 4.90983C13.4605 4.98016 13.5 5.07554 13.5 5.175V13.068Z"
        fill="#080708"
      />
      <path
        id="detail"
        d="M9.75 6.2998H5.25C4.83579 6.2998 4.5 6.63559 4.5 7.0498C4.5 7.46402 4.83579 7.7998 5.25 7.7998H9.75C10.1642 7.7998 10.5 7.46402 10.5 7.0498C10.5 6.63559 10.1642 6.2998 9.75 6.2998Z"
        fill="#FBDCCE"
      />
    </svg>
  )
}
